import React from "react";
import { Grid } from "semantic-ui-react";
import approveIconToggle from "../../../assets/icons/toggle-off-icon.svg";
import approvedIconToggle from "../../../assets/icons/toggle-on-icon.svg";
import previewIcon from "../../../assets/icons/preview-icon.svg";
import previewHoverIcon from "../../../assets/icons/preview-hover-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import ListActionIcon from "../../../app/common/components/ListActionIcon";
import { getFullDate } from "../../../js/helpers/dateHelpers";
import { closeModal, openModal } from "../../../app/common/modals/modalReducer";
import {
  ADMIN_COMPANY_REVIEW_MODAL,
  STANDARD_MODAL,
} from "../../../app/common/modals/ModalManager";
import CompanyProfilePreview from "../../employer/components/CompanyProfilePreview";
import { COMPANY_PROFILE_TYPE } from "../adminConstants";
import statsIcon from "../../../assets/icons/stats-icon.svg";
import statsHoverIcon from "../../../assets/icons/stats-icon-hover.svg";
import CompanyMetricsPane from "../../dashboards/components/CompanyMetricsPane";

export default function CompanyProfileListItem({
  company: companyProfile,
  type = COMPANY_PROFILE_TYPE.current,
}) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);

  return (
    <div className="job-list-item body-blue-text">
      <Grid style={{ paddingRight: 14 }} stackable>
        <Grid.Column
          width={4}
          verticalAlign="middle"
          textAlign="left"
          style={{ padding: 12 }}
        >
          {type === COMPANY_PROFILE_TYPE.underReview && (
            <>
              <span>Submitted: </span>
              <span>{getFullDate(companyProfile.dateSubmitted)}</span>
            </>
          )}
          {type === COMPANY_PROFILE_TYPE.current && (
            <>
              <span>Published: </span>
              <span>{getFullDate(companyProfile.datePublished)}</span>
            </>
          )}
        </Grid.Column>
        <Grid.Column width={8} verticalAlign="middle" style={{ padding: 12 }}>
          <div>{companyProfile.name}</div>
          <div>Company Profile Id: {companyProfile.id}</div>
          <div>Company Id: {companyProfile.companyId}</div>
        </Grid.Column>
        <Grid.Column
          width={3}
          verticalAlign="middle"
          textAlign={responsive.isComputer ? "right" : "left"}
          style={{ padding: 12 }}
        >
          <span
            className="job-list-item-action-icon clickable"
            data-testid={
              companyProfile.isApproved
                ? "admin-approved-button-testid"
                : "admin-approve-button-testid"
            }
            onClick={() =>
              dispatch(
                openModal({
                  modalType: ADMIN_COMPANY_REVIEW_MODAL,
                  modalProps: { companyProfile: companyProfile },
                })
              )
            }
          >
            <img
              style={{ width: 41, height: 18.3 }}
              src={
                companyProfile.isApproved
                  ? approvedIconToggle
                  : approveIconToggle
              }
              alt="toggle icon"
            />
          </span>
          <ListActionIcon
            dataTestId="preview-icon-testid"
            icon={previewIcon}
            onHoverIcon={previewHoverIcon}
            iconStyle={{ width: 28, height: 18.3 }}
            alt="preview"
            action={() =>
              dispatch(
                openModal({
                  modalType: STANDARD_MODAL,
                  modalProps: {
                    component: (
                      <CompanyProfilePreview
                        company={companyProfile}
                        clearAbove={false}
                      />
                    ),
                  },
                })
              )
            }
            text="View"
          />
          {companyProfile.isInitialised && (
            <ListActionIcon
              dataTestId="stats-icon-testid"
              icon={statsIcon}
              onHoverIcon={statsHoverIcon}
              iconStyle={{ width: 28, height: 18.3 }}
              alt="stats"
              text="Profile Activity"
              action={() => {
                dispatch(
                  openModal({
                    modalType: STANDARD_MODAL,
                    modalProps: {
                      component: (
                        <CompanyMetricsPane
                          company={companyProfile}
                          handleBack={() => dispatch(closeModal())}
                        />
                      ),
                    },
                  })
                );
              }}
            />
          )}
        </Grid.Column>
      </Grid>
    </div>
  );
}
